/**
 * Do not edit directly
 */

export default "PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNiAxNiIgdmlld0JveD0iMCAwIDE2IDE2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiMxMTEiPjxwYXRoIGQ9Im0uNiAyLjloMTQuOHYxaC0xNC44eiIvPjxwYXRoIGQ9Im0uNiA3LjVoMTQuOHYxaC0xNC44eiIvPjxwYXRoIGQ9Im0uNiAxMi4xaDE0Ljh2MWgtMTQuOHoiLz48L2c+PC9zdmc+";